import React from 'react';
import ConfirmModal from '../../../../../components/ConfirmModal';

export default function ResetWarningModal({
    isOpen,
    onClose,
    onSaveAndLeave,
    onLeaveWithoutSaving,
    currentLabel,
    nextLabel,
}) {
    return (
        <ConfirmModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onSaveAndLeave}
            onCancel={onLeaveWithoutSaving}
            title="Unsaved Changes"
            message={
                <>
                    You have unsaved changes in <strong>{currentLabel}</strong>.
                    <br />
                    Do you want to save before switching to <strong>{nextLabel}</strong>?
                </>
            }
            confirmText="Save & Leave"
            cancelText="Leave Without Saving"
        />
    );
}
